class CalibrationStatus {
    constructor() {
        this.CALIBRATED = { id: 1, name: 'calibrated', type: 'is-success' };
        this.NOT_CALIBRATED = { id: 2, name: 'not_calibrated', type: 'is-danger' };
        this.EXPIRED = { id: 3, name: 'expired', type: 'is-warning' };
        this.UNKNOWN = { id: 4, name: 'unknown', type: 'is-light' };
        this.NOT_AVAILABLE = { id: 5, name: 'not_available', type: 'is-grey' };
    }
}
export default new CalibrationStatus();
